import Router from "./Router";
import { HashRouter } from "react-router-dom";
import * as React from "react";

const App = () => {
  return (
		<HashRouter>
		  <Router />
		</HashRouter>
  );
};

export default App;
